// @flow
import classnames from 'classnames'
import moment from 'moment'
import {
  keysIn,
  map,
  pick 
} from 'ramda'
import React from 'react'

import { Button } from '@driftt/dds'
import { Table } from '@driftt/tide-table'

import { ImportsTableColumns } from './constants'

import './style.css'

const ErrorCell = ({
  count,
  url 
}) => (
  <div className="imports-table-error-cell" >
    <span>{count}</span>
    {url && 
      <Button 
        size="small" 
        variant="secondary"
        href={url}>
        View
      </Button> }
  </div>
)

const cellFormatter = (data, key, errorCsvUrl) => {
  const format = {
    importCreated: value => moment(value).format('MM/DD/YYYY'),
    importUpdated: value => moment(value ? value : data.importCreated).format('MM/DD/YYYY'),
    errors: value => value ? <ErrorCell count={value} url={errorCsvUrl}/> : value
  }

  return format[key] ? format[key](data[key]) : data[key]
}

const formatAccountDataForTable = (imports) => {
  const format = sync => {
    const data = pick(['importCreated', 'importUpdated', 'created', 'errors'], sync)
    const toContent = key => ({ content: cellFormatter(data, key, sync.errorCsvUrl) })
    const columns = [...keysIn(data)]

    return { data: map(toContent, columns) }
  }

  return map(format, imports)
}

const ImportsTable = ({
  imports = [],
  hasFinished 
}) => {
  return (
    <div>
      <Table
        className={classnames("imports-table", { 'imports-table--loaded': hasFinished }) }
        columns={ImportsTableColumns}
        data={formatAccountDataForTable(imports)}
      />
    </div>
  )
}

export default ImportsTable
